import * as React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAdminBrandForm } from "../../@hooks"


export default function AdminBrandsExcludedWordTextField({ disabled }) {
	const { value, handleChange } = useAdminBrandForm('excludedWord')

    return <TextFieldSeeker
		label="Excluded Word"
		placeholder="Please enter excluded words..."
		value={value}
		disabled={disabled}
		onChange={e => handleChange(e.target.value)}
	/>
}
